import React, { Component } from "react"
import InputBase from "@mui/material/InputBase"
import Typography from "@mui/material/Typography"
import Fade from "@mui/material/Fade"
import CircularProgress from "@mui/material/CircularProgress"
import LoadingButton from "@mui/lab/LoadingButton"
import Send from "@mui/icons-material/Send"
import Check from "@mui/icons-material/Check"
import Clear from "@mui/icons-material/Clear"
import { withTranslation } from "react-i18next"
import queryStringify from "querystringify"
import { sanitizeYaml } from "../../utilities"
import linkifyHtml from "linkify-html"

export default withTranslation()(
  class OpenEnded extends Component {
    state = { answer: null, answerLoading: false, isCorrect: null }

    answer = async (roomCode, participantId, answer) => {
      this.setState({ answerLoading: true })

      await fetch(
        `${
          process.env.REACT_APP_SERVER_URL
        }/room/answer?roomCode=${roomCode}&participantId=${participantId}&answer=${answer}&password=${localStorage.getItem(
          "password"
        )}`,
        {
          method: "POST",
          headers: {},
        }
      )
        .then(async (response) => {
          const isCorrect = await response.json()

          this.setState({ isCorrect })

          if (isCorrect) {
            this.props.setNextVisible()
          }
        })
        .catch(() =>
          this.setState({
            selectedAnswer: null,
          })
        )
        .finally(() => this.setState({ answerLoading: false }))
    }

    componentWillReceiveProps(nextProps) {
      if (
        this.props.slideNumber !== nextProps.slideNumber &&
        document.getElementById("open-ended-input-base")
      ) {
        this.setState({ answer: "", isCorrect: null })
        document.getElementById("open-ended-input-base").value = ""
      }
    }

    render() {
      const { text, t, correct, participantId } = this.props
      const { answer, answerLoading, isCorrect } = this.state

      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            maxWidth: "min(960px, calc(100% - 64px))",
            margin: "0 32px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              textTransform: "none",
              padding: "32px 48px",
              borderRadius: "24px",
              background: "rgba(255, 255, 255, .8)",
              backdropFilter: "blur(16px)",
              marginBottom: "16px",
            }}
          >
            <Typography
              variant="h3"
              style={{ overflow: "hidden", textOverflow: "ellipsis" }}
              dangerouslySetInnerHTML={{
                __html: linkifyHtml(sanitizeYaml(text), {
                  target: "_blank",
                  attributes: {
                    class: "underlineOnHover",
                  },
                }),
              }}
            />
          </div>
          {window.location.pathname === "/admin" ? (
            <div
              style={{
                textAlign: "center",
                textTransform: "none",
                padding: "32px 48px",
                borderRadius: "24px",
                background: "rgba(255, 255, 255, .8)",
                backdropFilter: "blur(16px)",
                marginBottom: "16px",
              }}
            >
              <Typography
                variant="h3"
                style={{
                  fontWeight: 300,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                dangerouslySetInnerHTML={{
                  __html: linkifyHtml(sanitizeYaml(correct), {
                    target: "_blank",
                    attributes: {
                      class: "underlineOnHover",
                    },
                  }),
                }}
              />
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                textTransform: "none",
                borderRadius: "24px",
                background: "rgba(255, 255, 255, .8)",
                backdropFilter: "blur(16px)",
                display: "flex",
              }}
            >
              <InputBase
                id="open-ended-input-base"
                fullWidth
                placeholder={t`Answer`}
                inputProps={{
                  style: {
                    fontSize: "3rem",
                    WebkitTextFillColor: "black",
                  },
                }}
                style={{
                  width: "calc(100% - 118px)",
                  padding: "20px 0 20px 48px",
                }}
                value={answer}
                onChange={(event) => {
                  this.setState({ answer: event.target.value, isCorrect: null })
                }}
                onKeyPress={(event) => {
                  if (
                    event.key === "Enter" &&
                    isCorrect === null &&
                    event.target.value
                  ) {
                    this.answer(
                      queryStringify.parse(window.location.search).room,
                      participantId,
                      event.target.value
                    )
                  }
                }}
                disabled={isCorrect}
              />
              <LoadingButton
                style={{
                  width: "118px",
                  color: "black",
                  borderRadius: 0,
                  borderTopRightRadius: "inherit",
                  borderBottomRightRadius: "inherit",
                }}
                onClick={() =>
                  isCorrect === null
                    ? this.answer(
                        queryStringify.parse(window.location.search).room,
                        participantId,
                        answer
                      )
                    : this.setState({ answer: "", isCorrect: null })
                }
                loading={answerLoading}
                loadingIndicator={
                  <Fade
                    in
                    style={{
                      transitionDelay: "800ms",
                    }}
                    unmountOnExit
                  >
                    <CircularProgress size={32} />
                  </Fade>
                }
                disabled={isCorrect || !answer}
              >
                <Fade in={!answerLoading && isCorrect === null} appear={false}>
                  <Send
                    style={{
                      fontSize: "3rem",
                      position: "absolute",
                      opacity: answer ? 1 : 0.5,
                    }}
                  />
                </Fade>
                <Fade in={isCorrect}>
                  <Check style={{ fontSize: "3rem", position: "absolute" }} />
                </Fade>
                <Fade in={isCorrect === false}>
                  <Clear style={{ fontSize: "3rem", position: "absolute" }} />
                </Fade>
              </LoadingButton>
            </div>
          )}
        </div>
      )
    }
  }
)
